module.exports = __webpack_public_path__ + "img/threesides.adccf91.svg";